import { render, staticRenderFns } from "./Lore.vue?vue&type=template&id=afba808c&scoped=true&"
import script from "./Lore.vue?vue&type=script&lang=js&"
export * from "./Lore.vue?vue&type=script&lang=js&"
import style0 from "./Lore.vue?vue&type=style&index=0&id=afba808c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afba808c",
  null
  
)

export default component.exports